const doc = [({"en":({"js":({"admin":({"toggle_eye_button":({"the_model_was_saved":"The model was saved."})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;